var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$vuetify.breakpoint.mobile)?_c('MessaggiDesktop',{attrs:{"messaggi":_vm.lista}}):_c('MessaggiMobile',{attrs:{"messaggi":_vm.lista}})}
var staticRenderFns = []

export { render, staticRenderFns }